module.exports = __webpack_public_path__ + "static/media/welcome-challenges.214f75b3.png";